function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 95,
  id: "b",
  r: 87
}), /*#__PURE__*/React.createElement("filter", {
  filterUnits: "objectBoundingBox",
  height: "131%",
  id: "a",
  width: "131%",
  x: "-15.5%",
  y: "-8.6%"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 12,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.269792798 0 0 0 0 0.513949697 0 0 0 0 0.686543367 0 0 0 0.482053895 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(6)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#149ffc",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.458 147c-2.969 0-5.435-.333-7.4-.998-1.963-.665-3.516-1.41-4.658-2.236-1.142-.826-1.94-1.617-2.398-2.374-.456-.757-.685-1.25-.685-1.48 0-.825.183-1.708.548-2.648a12.91 12.91 0 0 1 1.37-2.615 10.372 10.372 0 0 1 1.782-2.03c.64-.55 1.21-.825 1.713-.825.639 0 1.164.412 1.575 1.238l.685.688c.366.367.88.746 1.542 1.136.662.39 1.484.745 2.466 1.066.982.321 2.135.482 3.46.482 2.877 0 5.23-.883 7.056-2.65 1.827-1.765 2.74-4.162 2.74-7.19 0-2.11-.49-3.99-1.472-5.642-.982-1.651-2.272-3.188-3.87-4.61-1.6-1.422-3.426-2.81-5.482-4.163a433.647 433.647 0 0 1-6.303-4.232 87.191 87.191 0 0 1-6.302-4.747 31.698 31.698 0 0 1-5.481-5.849c-1.599-2.202-2.89-4.69-3.871-7.465C65.491 87.08 65 83.904 65 80.326c0-3.074.525-6.17 1.576-9.29 1.05-3.119 2.5-6.089 4.35-8.91a47.35 47.35 0 0 1 6.543-7.913 47.316 47.316 0 0 1 8.152-6.399 41.913 41.913 0 0 1 9.146-4.266c3.175-1.032 6.36-1.548 9.558-1.548 2.74 0 5.206.436 7.399 1.307 2.192.872 4.042 2.099 5.549 3.682 1.507 1.582 2.672 3.486 3.494 5.71.822 2.225 1.233 4.714 1.233 7.466a22.48 22.48 0 0 1-1.37 7.707 32.94 32.94 0 0 1-3.631 7.156 41.785 41.785 0 0 1-5.104 6.227c-1.896 1.903-3.837 3.555-5.823 4.954-1.987 1.399-3.917 2.488-5.79 3.268-1.872.78-3.516 1.17-4.932 1.17-1.233 0-2.341-.287-3.323-.86a8.57 8.57 0 0 1-2.466-2.133 10.586 10.586 0 0 1-1.542-2.684c-.365-.94-.548-1.777-.548-2.511 0-.597.08-.987.24-1.17.16-.183.388-.264.685-.24.297.022.674.09 1.13.206a6.5 6.5 0 0 0 1.576.172c1.918 0 4.042-.666 6.372-1.996 2.329-1.33 4.521-3.027 6.576-5.092a31.525 31.525 0 0 0 5.173-6.811c1.393-2.478 2.09-4.886 2.09-7.225 0-2.386-.583-4.266-1.747-5.642-1.165-1.377-3.14-2.065-5.927-2.065-1.735 0-3.62.333-5.652.998s-4.076 1.594-6.131 2.787c-2.056 1.192-4.042 2.637-5.96 4.335a33.555 33.555 0 0 0-5.07 5.607 28.669 28.669 0 0 0-3.529 6.606 20.795 20.795 0 0 0-1.335 7.397c0 2.706.49 5.126 1.472 7.259a21.994 21.994 0 0 0 3.906 5.814 36.355 36.355 0 0 0 5.515 4.817 276.561 276.561 0 0 0 6.302 4.369 155.956 155.956 0 0 1 6.303 4.472 35.513 35.513 0 0 1 5.515 5.092 23.617 23.617 0 0 1 3.905 6.193c.982 2.27 1.473 4.874 1.473 7.81 0 2.843-.536 5.538-1.61 8.084-1.073 2.546-2.546 4.76-4.418 6.64-1.873 1.88-4.088 3.372-6.646 4.473-2.558 1.1-5.298 1.651-8.221 1.651z",
  fill: "#fff"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "scatter-logo",
  viewBox: "0 0 202 208"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/scatter.a00b5c47.svg";
export { SvgComponent as ReactComponent };